export const REDUCER_NAME = 'correction'




// WEBPACK FOOTER //
// ./src/modules/invoice/state/correction/const.js